"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonIcon = _interopRequireDefault(require("../../../atoms/buttons/buttonIcon/ButtonIcon"));

var _Typography = _interopRequireDefault(require("../../../protons/typography/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dialog: {
      '& .MuiPaper-root': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    appBar: {
      boxShadow: 'none',
      position: 'relative',
      '& .MuiTypography-root': {
        margin: 'auto'
      }
    }
  };
});

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up",
    ref: ref
  }, props));
});

var DialogFullWidth = function DialogFullWidth(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      openDialog = _ref.openDialog,
      closeAction = _ref.closeAction,
      children = _ref.children,
      className = _ref.className;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: openDialog,
    scroll: "paper",
    fullScreen: true,
    className: (0, _classnames.default)(className, classes.dialog),
    TransitionComponent: Transition
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    className: classes.appBar
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "VfGrey",
    variant: "h5",
    text: title
  }), /*#__PURE__*/_react.default.createElement(_ButtonIcon.default, {
    variant: "transparentGrey",
    size: "small",
    icon: "ic_close",
    action: function action() {
      return closeAction();
    }
  }))), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, children)));
};

DialogFullWidth.prototype = {
  title: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),
  closeAction: _propTypes.default.action,
  openDialog: _propTypes.default.bool.isRequired,
  className: _propTypes.default.string
};
var _default = DialogFullWidth;
exports.default = _default;